<template>
  <div class="homePage" @click="()=>{this.dropdownFlag = false}">
    <Layout>
      <Sider
        hide-trigger
        style="background-image: linear-gradient(#37b0fe, #4b80f7)"
      >
        <Menu
          :active-name="activeIndex"
          :open-names="activeName"
          ref="menuName"
          width="auto"
          class="menu"
        >
          <div class="tab_title">莅视外科影像互动平台</div>
          <MenuItem
            v-show="roleInfo.tab1"
            name="1"
            class="first_item"
            :to="{ name: IsCenter == '2' ? 'DataTable' : IsCenter == '0' ? 'BaseDoctorPage' : 'DoctorFirstPage'}"
            ><img src="../assets/tab1.png" alt="" /> 首页</MenuItem
          >
          <Submenu name="2" v-show="roleInfo.tab2">
            <template slot="title">
              <img src="../assets/tab2.png" alt="" />
              案例管理
            </template>
            <MenuItem
              name="2-1"
              v-show="roleInfo.tab2_1"
              to="/HomePage/CaseDiscussion/tab_1"
              >案例讨论</MenuItem
            >
            <MenuItem
              name="2-2"
              v-show="roleInfo.tab2_2"
              :to="{ name: 'FollowupManagement' }"
              >随访管理</MenuItem
            >
          </Submenu>
          <Submenu name="3" v-show="roleInfo.tab3">
            <template slot="title">
              <img src="../assets/tab3.png" alt="" />
              管理后台
            </template>
            <MenuItem
              name="3-1"
              v-show="roleInfo.tab3_1"
              :to="{ name: adminFlag ? 'DoctorManagement' : 'DoctorManagementCenter' }"
              >医生管理</MenuItem
            >
            <MenuItem
              name="3-2"
              v-show="roleInfo.tab3_2"
              :to="{ name: 'DoctorScheduling' }"
              >医生排班</MenuItem
            >
            <MenuItem
              name="3-3"
              v-show="roleInfo.tab3_3"
              :to="{ name: 'AccountManage' }"
              >平台账号管理</MenuItem
            >
            <MenuItem
              name="3-5"
              v-show="roleInfo.tab3_5"
              :to="{ name: 'TerminalSetting' }"
              >医技终端管理</MenuItem
            >
            <MenuItem
              name="3-4"
              v-show="roleInfo.tab3_4"
              :to="{ name: 'logPage' }"
              >系统日志</MenuItem
            >
          </Submenu>
          <!-- <Submenu name="4" v-show="roleInfo.tab4">
            <template slot="title">
              <img src="../assets/tab4.png" alt="" />
              教学管理(开发中)
            </template>
            <MenuItem name="4-1" v-show="roleInfo.tab4_1">手术直播</MenuItem>
            <MenuItem name="4-2" v-show="roleInfo.tab4_2">教学课程</MenuItem>
          </Submenu>
          <Submenu name="5" v-show="roleInfo.tab5">
            <template slot="title">
              <img src="../assets/tab5.png" alt="" />
              学术社区(开发中)
            </template>
            <MenuItem
              name="5-1"
              v-show="roleInfo.tab5_1"
              :to="{ name: 'AcademicCommunity' }"
              >学术社区</MenuItem
            >
            <MenuItem name="5-2" v-show="roleInfo.tab5_2" :to="{ name: 'MyArticles' }"
              >我的文章</MenuItem
            >
          </Submenu> -->
          <MenuItem
            v-show="roleInfo.tab1"
            name="6"
            class="first_item"
            :to="{ name:'OperationGuide' }"
            ><img src="../assets/tab6.png" alt="" /> 远程手术指导</MenuItem
          >
        </Menu>
      </Sider>
      <Header style="background: #fff">
        <div class="my_header">
          <span>{{ title }}</span>
          <div class="doctorInfo">
            <!-- <div>
              <Icon
                type="ios-help-circle-outline"
                size="16"
                style="margin-right: 8px; font-weight: bold; color: #bbb"
              />
              帮助
            </div> -->
            <div>
              <Dropdown
                trigger="custom"
                :visible="dropdownFlag"
                @on-click="dropdownOpration"
              >
                <span class="userInfo" @click="dropdownClick">
                  <img :src="loginPhoto" alt="" v-if="loginPhoto" />
                  {{ loginName }}
                  <span style="margin-left: 6px">
                    <Icon
                      type="ios-arrow-dropup-circle"
                      color="#38B1FF"
                      size="15"
                      v-if="dropdownFlag"
                    />
                    <Icon
                      type="ios-arrow-dropdown-circle"
                      color="#38B1FF"
                      size="15"
                      v-else
                    />
                  </span>
                </span>
                <DropdownMenu slot="list">
                  <DropdownItem name="1" v-if="ImgUrlFlag && !adminFlag">我的信息</DropdownItem>
                  <DropdownItem name="2">退出</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Header>
      <Content>
        <router-view @funChangeTitle="changeTitle"></router-view>
      </Content>
    </Layout>
  </div>
</template>

<script>
import {
  Layout,
  Header,
  Menu,
  MenuItem,
  Icon,
  Sider,
  Submenu,
  Breadcrumb,
  BreadcrumbItem,
  Content,
  Button,
  Modal,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "view-design";
import Request from "../utils/request"
export default {
  components: {
    Layout,
    Header,
    Menu,
    MenuItem,
    Icon,
    Sider,
    Submenu,
    Breadcrumb,
    BreadcrumbItem,
    Content,
    Button,
    Modal,
    Dropdown,
    DropdownMenu,
    DropdownItem,
  },
  data() {
    return {
      IsCenter: localStorage.getItem("center"),
      ImgUrlFlag: JSON.parse(localStorage.getItem("Role")).ImgUrl ? true : false,
      adminFlag: JSON.parse(localStorage.getItem("Role")).RoleID == "3" ? true : false,
      CenterAdmin:JSON.parse(localStorage.getItem("Role")).Role == '中心管理员' ? true : false,
      title: "首页",
      activeIndex: "1",
      activeName: ["1"],
      loginName: JSON.parse(localStorage.getItem("Role")).DocName,
      loginPhoto: JSON.parse(localStorage.getItem("Role")).ImgUrl,
      modal: false, //退出框
      moduleJson: JSON.parse(
        JSON.parse(localStorage.getItem("Role")).ModuleJson
      ),
      roleInfo: {
        tab1: false,
        tab2: false,
        tab3: false,
        tab4: false,
        tab5: false,
        tab2_1: false,
        tab2_2: false,
        tab3_1: false,
        tab3_2: false,
        tab3_3: false,
        tab3_4: false,
        tab3_5: false,
        tab4_1: false,
        tab4_2: false,
        tab5_1: false,
        tab5_2: false,
      },
      dropdownFlag: false,
    };
  },
  methods: {
    /* 点击头像下拉菜单中的某一项 */
    dropdownOpration(name) {
      this.dropdownFlag = false;
      if (name == 1) {
        this.$router.push({ name: "PersonalInformation" });
      } else if (name == 2) {
        this.$router.replace("/LoginPage");
        localStorage.clear();
        Request.addLog('退出','退出系统')
      }
    },
    /* 点击头像信息 */
    dropdownClick(e) {
      e.stopPropagation()
      this.dropdownFlag = !this.dropdownFlag;
    },
    changeTitle(name, index) {
      let index1 = index.indexOf("-") == -1 ? index : index.split("-")[0];
      this.title = name;
      this.activeIndex = index;
      this.activeName = [index1];
      this.$nextTick(() => {
        this.$refs.menuName.updateOpened();
        this.$refs.menuName.updateActiveName();
      });
    },
    /* 获取权限信息 */
    getRoleInfo() {
      this.moduleJson.map((item) => {
        if (item.ModuleName == "首页") {
          this.roleInfo.tab1 = true;
        } else if (item.ModuleName == "案例管理") {
          this.roleInfo.tab2 = true;
        } else if (item.ModuleName == "管理后台") {
          this.roleInfo.tab3 = true;
        } else if (item.ModuleName == "教学管理") {
          this.roleInfo.tab4 = true;
        } else if (item.ModuleName == "学术社区") {
          this.roleInfo.tab5 = true;
        }
        item.SubModule.map((item1) => {
          if (item1.SubName == "案例讨论") {
            this.roleInfo.tab2_1 = true;
          } else if (item1.SubName == "随访管理") {
            this.roleInfo.tab2_2 = true;
          } else if (item1.SubName == "医生管理") {
            this.roleInfo.tab3_1 = true;
          } else if (item1.SubName == "医生排班") {
            this.roleInfo.tab3_2 = true;
          } else if (item1.SubName == "平台账号管理") {
            this.roleInfo.tab3_3 = true;
          } else if (item1.SubName == "系统日志") {
            this.roleInfo.tab3_4 = true;
          }else if (item1.SubName == "医技终端管理") {
            this.roleInfo.tab3_5 = true;
          }else if (item1.SubName == "手术直播") {
            this.roleInfo.tab4_1 = true;
          } else if (item1.SubName == "教学课程") {
            this.roleInfo.tab4_2 = true;
          } else if (item1.SubName == "学术社区") {
            this.roleInfo.tab5_1 = true;
          } else if (item1.SubName == "我的文章") {
            this.roleInfo.tab5_2 = true;
          }
        });
      });
    },
  },
  created() {
    // console.log("进入首页");
    this.getRoleInfo();
  },
};
</script>

<style scoped lang="less">
.homePage {
  position: relative;
  width: 100%;
  height: 100%;
  .tab_title {
    font-size: 18px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
  }
  .ivu-layout-sider {
    position: absolute;
    width: 224px !important;
    min-width: 224px !important;
    max-width: 224px !important;
    flex: 0 0 224px !important;
    left: 0;
    top: 0;
    bottom: 0;
  }
  .ivu-layout-header {
    position: absolute;
    left: 224px;
    right: 0;
    padding: 0 50px 0 20px;
  }
  .ivu-menu-item {
    color: #fff;
    background: #0073d3;
  }
  .first_item {
    background: none;
    font-size:15px;
  }
  .ivu-layout-content {
    position: absolute;
    top: 64px;
    bottom: 0;
    right: 0;
    left: 224px;
    background: #fff;
    margin: 15px;
    overflow-y: auto;
  }
  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #0166b9;
    color: #fff;
  }
  .menu {
    font-size: 15px;
    color: #fff;
    background: none;
    img {
      width: 25px;
      height: 25px;
      margin-right: 10px;
      vertical-align: bottom;
    }
  }
  .my_header {
    display: flex;
    justify-content: space-between;
    & > span {
      color: #1890ff;
      font-size: 20px;
      font-weight: 700;
    }
    .doctorInfo {
      display: flex;
      align-items: flex-end;
      div {
        display: flex;
        align-items: center;
      }
      /* div:first-child {
        margin-right: 25px;
      } */
      .userInfo {
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          width: 40px;
          height: 40px;
          margin-right: 5px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
